(() => {
  const MIN = 5;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const kr = (c) => new Intl.NumberFormat('nb-NO', { style: 'currency', currency: 'NOK', maximumFractionDigits: 0 }).format(c / 100);
  const readJSON = (id) => { const el = document.getElementById(id); try { return el ? JSON.parse(el.textContent) : null; } catch (_) { return null; } };
  const mm = (s) => parseFloat(String(s || '').replace(',', '.'));
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const store = { get(k) { try { return localStorage.getItem(k); } catch (_) { return null; } }, set(k, v) { try { localStorage.setItem(k, v); } catch (_) {} } };

  const COLORS = {
    'hvit': '#ffffff', 'gul': '#f6cf00', 'klar': '#e9eef4', 'rød': '#d42a2a', 'blå': '#1f5fbf', 'grønn': '#2e9a4a', 'svart': '#151515',
    'gull': '#c9a227', 'sølv': '#c3c8ce'
  };
  const MATT = { 'hvit': '#f1f1ee', 'klar': '#dfe4ea', 'sølv': '#b3b8be' };
  const tapeColors = (name) => {
    const n = String(name || '').toLowerCase().trim();
    const [txt, bgRaw = 'hvit'] = n.split(' på ');
    const matt = bgRaw.startsWith('matt ');
    const bgKey = bgRaw.replace(/^matt\s+/, '');
    const bg = (matt && MATT[bgKey]) || COLORS[bgKey] || COLORS.hvit;
    const fg = txt === 'hvit' ? '#ffffff' : (COLORS[txt] && txt !== 'klar' ? COLORS[txt] : '#111111');
    return { bg, fg };
  };

  /* Fargeprøver */
  document.querySelectorAll('[data-sw]').forEach((el) => {
    const c = tapeColors(el.dataset.sw);
    el.style.background = c.bg;
    el.style.color = c.fg;
    el.textContent = 'Aa';
  });

  /* Antallsvelger */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-step]');
    if (!b) return;
    const wrap = b.closest('[data-stepper]');
    const input = wrap.querySelector('[data-qty]');
    const min = Number(wrap.dataset.min || 0);
    input.value = Math.max(min, Number(input.value || 0) + Number(b.dataset.step));
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  const toast = (html) => {
    const t = document.querySelector('[data-toast]');
    if (!t) return;
    t.innerHTML = html; t.hidden = false;
    clearTimeout(t._h); t._h = setTimeout(() => (t.hidden = true), 5000);
  };

  /* ---------- Maskinvelger ---------- */
  const finder = document.querySelector('[data-finder]');
  const machines = readJSON('fr-machines');
  const catalog = readJSON('fr-catalog');
  if (finder && machines && catalog) {
    const brandSel = finder.querySelector('[data-brand]');
    const machSel = finder.querySelector('[data-machine]');
    const results = document.querySelector('[data-results]');
    const resetBtn = document.querySelector('[data-finder-reset]');
    const title = document.querySelector('[data-result-title]');
    const eyebrow = document.querySelector('[data-result-eyebrow]');
    const sub = document.querySelector('[data-result-sub]');
    const all = [];
    machines.brands.forEach((b) => b.series.forEach((s) => s.machines.forEach((m) => all.push({ brand: b.name, series: s.name, ...m }))));

    const fillMachines = () => {
      const b = brandSel.value;
      machSel.innerHTML = '';
      if (!b) { machSel.disabled = true; machSel.innerHTML = '<option value="">Velg merke først</option>'; return; }
      machSel.disabled = false;
      machSel.insertAdjacentHTML('beforeend', '<option value="">Velg maskin</option>');
      machines.brands.find((x) => x.name === b).series.forEach((s) => {
        const g = document.createElement('optgroup');
        g.label = `${b} ${s.name}`;
        s.machines.forEach((m) => { const o = document.createElement('option'); o.value = m.model; o.textContent = m.model; g.appendChild(o); });
        machSel.appendChild(g);
      });
    };

    const fallbackSvg = '<svg viewBox="0 0 320 240" aria-hidden="true"><rect width="320" height="240" fill="#f2f6fb"/><rect x="56" y="34" width="208" height="140" rx="16" fill="#25303a"/><rect x="70" y="48" width="180" height="48" rx="8" fill="#36424d"/><circle cx="118" cy="134" r="22" fill="#141a1f"/><circle cx="202" cy="134" r="22" fill="#141a1f"/><rect x="30" y="168" width="260" height="40" rx="3" fill="#fff" stroke="#ccd6e2"/></svg>';

    const tierLbl = (t) => (machines.tiers && machines.tiers[t]) || { label: '', sub: '' };
    const tierBadge = (t) => (t > 0 ? `<span class="fr-tier fr-tier--${t}"><span class="fr-tier__dots" aria-hidden="true"><i></i><i></i><i></i></span>${esc(tierLbl(t).label)}</span>` : '');
    let sortMode = store.get('fr-sort') === 'tier' ? 'tier' : 'type';
    let lastMachine = null;

    const card = ({ p, fam, vs, widths, isWidth }) => `
      <a class="fr-card" href="${p.url}?variant=${vs[0].id}">
        <span class="fr-card__media">${p.img ? `<img src="${p.img}" alt="${esc(p.title)}" loading="lazy">` : fallbackSvg}</span>
        <span class="fr-card__body">
          <span class="fr-card__top"><span class="fr-card__type">${esc(sortMode === 'tier' ? fam.cat : p.type)}</span>${sortMode === 'tier' ? (fam.tier ? `<span class="fr-chip">Til ${esc(fam.use.toLowerCase())}</span>` : '') : tierBadge(fam.tier)}</span>
          <span class="fr-card__title">${esc(p.title)}</span>
          ${fam.best ? `<span class="fr-card__best">Best til: ${esc(fam.best)}</span>` : ''}
          <span class="fr-chips">${(isWidth ? widths : widths.map((w) => w.split(' · ')[0])).slice(0, 8).map((w) => `<span>${esc(w)}</span>`).join('')}</span>
          <span class="fr-card__foot"><span class="fr-card__price"><small>fra</small> ${esc(p.from)} <small>eks. mva</small></span><span class="fr-card__go" aria-hidden="true">→</span></span>
        </span>
      </a>`;

    const render = (machine) => {
      lastMachine = machine;
      const groups = {};
      catalog.forEach((p) => {
        const fam = machines.families[p.fam];
        if (!fam) return;
        let max = null;
        if (machine) { if (!(p.fam in machine.fits)) return; max = machine.fits[p.fam]; }
        const isWidth = p.options[0] === 'Bredde';
        const vs = p.variants.filter((v) => !isWidth || max === null || mm(v.o1) <= max + 0.01);
        if (!vs.length) return;
        const widths = [...new Set(vs.map((v) => v.o1))];
        const t = fam.tier || 0;
        const key = sortMode === 'tier' ? tierLbl(t).label : fam.cat;
        const order = sortMode === 'tier' ? (t ? 3 - t : 9) : fam.order;
        const sub = sortMode === 'tier' ? tierLbl(t).sub : '';
        (groups[key] = groups[key] || { order, sub, tier: sortMode === 'tier' ? t : -1, items: [] }).items.push({ p, fam, vs, widths, isWidth });
      });
      const cats = Object.entries(groups).sort((a, b) => a[1].order - b[1].order);
      if (!cats.length) { results.innerHTML = '<p class="fr-muted">Vi har ingen bånd til denne maskinen ennå. Spør oss, så skaffer vi det.</p>'; return; }
      cats.forEach(([, g]) => g.items.sort((a, b) => (b.fam.tier || 0) - (a.fam.tier || 0) || a.fam.order - b.fam.order));
      results.innerHTML = `<div class="fr-board${sortMode === 'tier' ? ' fr-board--tier' : ''}">` + cats.map(([cat, g]) => `
        <div class="fr-col${g.tier >= 0 ? ' fr-col--t' + g.tier : ''}">
          <div class="fr-col__head">
            <h3 class="fr-col__title">${g.tier > 0 ? tierBadge(g.tier) : esc(cat)} <small>${g.items.length}</small></h3>
            ${g.sub ? `<p class="fr-col__sub">${esc(g.sub)}</p>` : ''}
          </div>
          <div class="fr-stack">${g.items.map(card).join('')}</div>
        </div>`).join('') + '</div>';
    };

    const sortBtns = document.querySelectorAll('[data-sort]');
    const setSort = (mode) => {
      sortMode = mode;
      store.set('fr-sort', mode);
      sortBtns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.sort === mode)));
    };
    sortBtns.forEach((b) => b.addEventListener('click', () => { setSort(b.dataset.sort); render(lastMachine); }));
    setSort(sortMode);

    const apply = (scroll) => {
      const m = all.find((x) => x.model === machSel.value && x.brand === brandSel.value);
      render(m || null);
      if (m) {
        eyebrow.textContent = `${m.brand} ${m.series}`;
        title.textContent = `Bånd som passer ${m.model}`;
        sub.textContent = 'Bare bredder maskinen tar er vist. Klikk et produkt for å velge bredde og farge.';
        resetBtn.hidden = false;
        store.set('fr-machine', JSON.stringify({ b: m.brand, m: m.model }));
      } else {
        eyebrow.textContent = 'Hele sortimentet';
        title.textContent = 'Alle bånd og etiketter';
        sub.textContent = 'Velg maskin over for å se bare det som passer, med riktige bredder.';
        resetBtn.hidden = true;
      }
      if (scroll && m) document.getElementById('resultat').scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    brandSel.addEventListener('change', () => { fillMachines(); apply(false); });
    machSel.addEventListener('change', () => apply(true));
    finder.querySelector('[data-finder-go]').addEventListener('click', (e) => { e.preventDefault(); apply(true); if (!machSel.value) document.getElementById('resultat').scrollIntoView({ behavior: 'smooth' }); });
    resetBtn.addEventListener('click', () => { brandSel.value = ''; fillMachines(); store.set('fr-machine', ''); apply(false); });

    try {
      const saved = JSON.parse(store.get('fr-machine') || 'null');
      if (saved && saved.b) { brandSel.value = saved.b; fillMachines(); machSel.value = saved.m; }
    } catch (_) {}
    apply(false);
  }

  /* ---------- Produktside ---------- */
  const pdp = document.querySelector('[data-pdp]');
  const pj = (() => { const el = document.querySelector('[data-product-json]'); try { return el ? JSON.parse(el.textContent) : null; } catch (_) { return null; } })();
  if (pdp && pj) {
    const form = pdp.querySelector('[data-pdp-form]');
    const idInput = form.querySelector('[data-variant-id]');
    const qty = form.querySelector('[data-qty]');
    const line = form.querySelector('[data-line]');
    const addBtn = form.querySelector('[data-add]');
    const fieldsets = [...form.querySelectorAll('[data-opt]')];
    const img = pdp.querySelector('[data-pdp-img]');
    const svgWrap = pdp.querySelector('[data-pdp-svg]');
    const imgnote = pdp.querySelector('[data-imgnote]');
    const fam = pdp.dataset.fam;
    const toEks = (p) => (pj.taxIncl ? Math.round(p * 0.8) : p);
    const toInkl = (p) => (pj.taxIncl ? p : Math.round(p * 1.25));
    let current = pj.variants.find((v) => String(v.id) === idInput.value) || pj.variants[0];
    const sel = [...current.o];

    const find = (s) => pj.variants.find((v) => v.o.every((x, i) => x === null || x === s[i]));
    const exists = (i, val) => pj.variants.some((v) => v.o[i] === val && v.o.every((x, j) => j === i || j >= fieldsets.length || x === sel[j]));

    const renderFits = () => {
      const ul = pdp.querySelector('[data-fits]');
      if (!ul || !machines) return;
      const w = pj.options[0] === 'Bredde' ? mm(current.o[0]) : 0;
      const rows = [];
      machines.brands.forEach((b) => b.series.forEach((s) => s.machines.forEach((m) => {
        if (!(fam in m.fits)) return;
        const ok = m.fits[fam] + 0.01 >= w;
        rows.push(`<li class="${ok ? 'is-ok' : 'is-no'}"><span>${esc(b.name)} ${esc(m.model)}</span><small>${m.fits[fam] >= 999 ? 'Alle størrelser' : (ok ? 'Passer' : 'Maks ' + String(m.fits[fam]).replace('.', ',') + ' mm')}</small></li>`);
      })));
      ul.innerHTML = rows.join('') || '<li>Se produktbeskrivelsen.</li>';
    };

    const update = () => {
      fieldsets.forEach((fs, i) => {
        fs.querySelector('[data-opt-label]').textContent = sel[i];
        fs.querySelectorAll('[data-value]').forEach((b) => {
          b.setAttribute('aria-pressed', b.dataset.value === sel[i]);
          b.classList.toggle('is-na', !exists(i, b.dataset.value));
        });
      });
      current = find(sel) || current;
      idInput.value = current.id;
      pdp.querySelector('[data-sku]').textContent = current.sku;
      pdp.querySelector('[data-orig]').textContent = current.orig;
      pdp.querySelector('[data-price-eks]').textContent = kr(toEks(current.price));
      pdp.querySelector('[data-price-inkl]').textContent = kr(toInkl(current.price));
      pdp.querySelector('[data-eks]').dataset.eks = toEks(current.price);
      addBtn.disabled = !current.available;
      addBtn.textContent = current.available ? 'Legg i handlekurv' : 'Utsolgt';
      if (pdp.dataset.mrClean === 'true') {
        const fixedSrc = pdp.querySelector('.fr-pdp__main')?.dataset.masterPhoto;
        if (fixedSrc) { img.src = fixedSrc; img.hidden = false; svgWrap.hidden = true; }
        if (imgnote) imgnote.hidden = true;
      } else if (current.img) { img.src = current.img; img.hidden = false; svgWrap.hidden = true; if (imgnote) imgnote.hidden = true; }
      else {
        img.hidden = true; svgWrap.hidden = false; if (imgnote) imgnote.hidden = false;
        const color = pj.options.indexOf('Farge') > -1 ? current.o[pj.options.indexOf('Farge')] : 'Svart på hvit';
        const c = tapeColors(color);
        svgWrap.querySelectorAll('[data-tape-bg]').forEach((r) => r.setAttribute('fill', c.bg));
        svgWrap.querySelectorAll('[data-tape-fg]').forEach((t) => { t.setAttribute('fill', c.fg); if (t.textContent !== '-W12 24V') t.textContent = current.sku; });
      }
      try { history.replaceState(null, '', `?variant=${current.id}`); } catch (_) {}
      renderFits();
      updLine();
    };

    const updLine = () => {
      const q = Math.max(MIN, Number(qty.value || MIN));
      const pct = q >= 50 ? 0.15 : q >= 25 ? 0.1 : q >= 10 ? 0.05 : 0;
      const eks = toEks(current.price);
      line.innerHTML = `${q} stk = <b>${kr(q * eks * (1 - pct))}</b> eks. mva${pct ? ` <span class="fr-chip fr-chip--ok">−${Math.round(pct * 100)} %</span>` : ''}`;
      let active = '0';
      pdp.querySelectorAll('[data-tier]').forEach((t) => { if (q >= Number(t.dataset.tier)) active = t.dataset.tier; });
      pdp.querySelectorAll('[data-tier]').forEach((t) => t.classList.toggle('is-active', t.dataset.tier === active));
    };

    /* Bra / bedre / best-alternativer i samme bruksområde */
    const alt = pdp.querySelector('[data-alt]');
    const myFam = machines && machines.families[fam];
    if (alt && catalog && myFam && myFam.tier > 0) {
      const brandOf = (f) => { let n = ''; machines.brands.forEach((b) => b.series.forEach((s) => s.machines.forEach((m) => { if (f in m.fits) n = b.name; }))); return n; };
      const lbl = (t) => (machines.tiers[t] || {}).label || '';
      const seen = new Set();
      const list = catalog
        .filter((p) => { const f = machines.families[p.fam]; if (!f || f.use !== myFam.use || brandOf(p.fam) !== brandOf(fam) || seen.has(p.fam)) return false; seen.add(p.fam); return true; })
        .sort((a, b) => machines.families[b.fam].tier - machines.families[a.fam].tier);
      if (list.length > 1) {
        alt.querySelector('[data-alt-sub]').textContent = myFam.use === 'Kabel' ? `Alternativer for kabel og ledning til ${brandOf(fam)}-maskiner` : `Alternativer for flater, tavler og utstyr til ${brandOf(fam)}-maskiner`;
        alt.querySelector('[data-alt-list]').innerHTML = list.map((p) => {
          const f = machines.families[p.fam];
          const me = p.fam === fam;
          return `<li class="${me ? 'is-current' : ''}"><span class="fr-tier fr-tier--${f.tier}"><span class="fr-tier__dots" aria-hidden="true"><i></i><i></i><i></i></span>${esc(lbl(f.tier))}</span>`
            + `<span class="fr-alt__txt">${me ? `<b>${esc(p.title)}</b>` : `<a href="${p.url}">${esc(p.title)}</a>`}<small>${esc(f.best)}</small></span>`
            + `${me ? '<em>Du ser på denne</em>' : ''}</li>`;
        }).join('');
        alt.hidden = false;
      }
    }

    fieldsets.forEach((fs, i) => fs.addEventListener('click', (e) => {
      const b = e.target.closest('[data-value]');
      if (!b) return;
      sel[i] = b.dataset.value;
      if (!find(sel)) {
        const alt = pj.variants.find((v) => v.o[i] === sel[i]);
        if (alt) alt.o.forEach((x, j) => { if (j < fieldsets.length) sel[j] = x; });
      }
      update();
    }));
    qty.addEventListener('input', updLine);
    qty.addEventListener('change', () => { if (Number(qty.value) < MIN) qty.value = MIN; updLine(); });

    pdp.querySelectorAll('[data-thumb]').forEach((t) => t.addEventListener('click', () => { img.src = t.dataset.thumb; img.hidden = false; svgWrap.hidden = true; }));

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (Number(qty.value) < MIN) qty.value = MIN;
      addBtn.disabled = true; addBtn.textContent = 'Legger til …';
      try {
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: current.id, quantity: Number(qty.value) }] }) });
        if (!r.ok) throw new Error((await r.json()).description || 'Noe gikk galt');
        const c = await (await fetch(root + 'cart.js')).json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => (el.textContent = c.item_count));
        toast(`<b>${qty.value} stk ${esc(current.sku)}</b> lagt i handlekurven. <a href="${root}cart">Gå til handlekurv →</a>`);
      } catch (err) { toast('Kunne ikke legge til: ' + esc(err.message)); }
      finally { addBtn.disabled = !current.available; addBtn.textContent = 'Legg i handlekurv'; }
    });

    update();
  }

  /* ---------- Handlekurv ---------- */
  const cart = document.querySelector('[data-cart-form]');
  if (cart) {
    const check = () => {
      let bad = 0;
      cart.querySelectorAll('[data-line]').forEach((l) => {
        const q = Number(l.querySelector('[data-qty]').value || 0);
        const inv = q > 0 && q < MIN;
        l.classList.toggle('is-invalid', inv);
        l.querySelector('[data-warn]').hidden = !inv;
        if (inv) bad++;
      });
      cart.querySelector('[data-cart-msg]').hidden = !bad;
      cart.querySelector('[data-checkout]').disabled = !!bad;
    };
    cart.addEventListener('input', check);
    check();
  }
})();
